/** Tarih yardımcıları. Belge tarihi DATE (saat dilimsiz); sistem zamanları UTC ISO. */

const TZ = 'Europe/Istanbul';

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}.${m}.${y}`;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat('tr-TR', {
    timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }).format(new Date(iso));
}

/** Belge saati: hassasiyete göre; yoksa "Saat bilgisi yok" (PDF §04). Saniye uydurulmaz. */
export function formatDocTime(time: string | null | undefined, precision: string | null | undefined): string {
  if (!time || precision === 'DATE' || !precision) return 'Saat bilgisi yok';
  return precision === 'MINUTE' ? time.slice(0, 5) : time.slice(0, 8);
}

export function todayTR(): string {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  return parts; // YYYY-MM-DD
}

/** Sistem zamanı (UTC ISO) → Türkiye saatiyle tarih (YYYY-AA-GG) ve saat (SS:DD). */
export function isoToTR(iso: string): { date: string; time: string } {
  const d = new Date(iso);
  const date = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  const time = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false }).format(d);
  return { date, time };
}

export function currentYearMonth(): string {
  return todayTR().slice(0, 7);
}

const MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

export function yearMonthLabel(ym: string): string {
  const [y, m] = ym.split('-');
  return `${MONTHS[Number(m) - 1] ?? m} ${y}`;
}
